import { render, staticRenderFns } from "./PSelfIntroduction.vue?vue&type=template&id=9576e4c8&"
import script from "./PSelfIntroduction.vue?vue&type=script&lang=ts&"
export * from "./PSelfIntroduction.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports